var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwap40 = function SvgSwap40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18Zm2.162-28.33-6.93.004-.153.01a1.226 1.226 0 0 0-1.071 1.216l.01.154a1.226 1.226 0 0 0 1.216 1.071l3.978-.002-9.178 9.178-.095.107a1.226 1.226 0 0 0 .095 1.626l.107.095c.48.381 1.182.35 1.626-.095l9.172-9.172.003 3.972.01.154a1.226 1.226 0 0 0 2.44-.155l-.004-6.938-.01-.153a1.226 1.226 0 0 0-1.216-1.072Zm7.802 7.3-.107-.096a1.226 1.226 0 0 0-1.626.096l-9.169 9.168-.002-3.972-.01-.154a1.226 1.226 0 0 0-2.442.155l.004 6.936.01.154a1.226 1.226 0 0 0 1.216 1.071l6.93-.003.153-.01a1.226 1.226 0 0 0 1.072-1.216l-.01-.154a1.226 1.226 0 0 0-1.216-1.071l-3.975.001 9.172-9.172.095-.107c.381-.481.35-1.182-.095-1.626Z",
    fill: "#666"
  })));
};
export default SvgSwap40;